
import { defineComponent, ref, reactive } from 'vue'
import { useContextmenu } from './use-contextmenu'
import { contextmenuProps, contextmenuEmits } from './contextmenus'
export default defineComponent({
  name: 'Contextmenu',
  props: contextmenuProps,
  emits: contextmenuEmits,
  setup (props, ctx) {
    const inputRef = ref<HTMLInputElement>()
    const eleRef = ref<HTMLElement>()
    const copyText = ref('')
    const oldData = reactive({})
    const contextmenu = useContextmenu(props, ctx, { inputRef, eleRef })

    return {
      eleRef,
      inputRef,
      copyText,
      oldData,
      ...contextmenu
    }
  }

})
